import { render, staticRenderFns } from "./OnSuppGuidance.vue?vue&type=template&id=6d601870&lang=pug"
import script from "./OnSuppGuidance.vue?vue&type=script&lang=js"
export * from "./OnSuppGuidance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports